module.exports = __webpack_public_path__ + "img/growcify-rungta-banner.63abe4db.png";